import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const hTags = {
    1: 'h1',
    2: 'h2',
    3: 'h3',
};
const Title = ({ level, children, className, primary, ...props }) => {
    const cls = classnames('nd-title', className, { primary });
    const Tag = hTags[level] || hTags[1];
    return (
        <Tag {...props} className={cls}>
            {children}
        </Tag>
    );
};

Title.propTypes = {
    level: PropTypes.oneOf(['1', '2', '3']),
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
    className: PropTypes.string,
    primary: PropTypes.bool,
};
Title.defaultProps = {
    level: '1',
    className: '',
    primary: false,
};
export default Title;
